import ViewCaseManager from "./ViewCaseManager";

export default ViewCaseManager;
